import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { contact, images, navLinks } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return <header className="sticky top-0 z-50 w-full" data-id="element-158" data-mp="qxfcxq3k60wk">
      <div className="hidden bg-navy-dark text-white md:block" data-id="element-159" data-mp="qyqhvt8qpep9">
        <div className="mx-auto flex max-w-7xl items-center justify-end gap-8 px-6 py-2 text-[13px]" data-id="element-160" data-mp="14x7zrabyrwz9">
          <a href={contact.phoneHref} className="flex items-center gap-2 transition-colors hover:text-gold-light" data-id="element-161" data-mp="zwkbgwf4du8q">
            <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-162" data-mp="2bch7t5pafgfz" />
            {contact.phone}
          </a>
          <a href={`mailto:${contact.email}`} className="flex items-center gap-2 transition-colors hover:text-gold-light" data-id="element-163" data-mp="29k29cdhavhte">
            <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-164" data-mp="2eh2ac9zaludn" />
            {contact.email}
          </a>
          <span className="text-white/75" data-id="element-165" data-mp="2jfx2w3n2axay">{contact.hours}</span>
        </div>
      </div>

      <div className="border-b border-gray-200 bg-white" data-id="element-166" data-mp="2ogb6n9hmrl36">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4" data-id="element-167" data-mp="1qu3wlk2k50jf">
          <Link to="/" className="flex items-center" aria-label="Guernsey Cleaning — home" data-id="element-168" data-mp="1vrvtksi27cuh">
            <img src={images.logo} alt="Guernsey Cleaning — Clean Spaces. Better Places." className="h-11 w-auto sm:h-12" data-id="element-169" data-mp="20qyrlszmgisy" />
          </Link>

          <nav className="hidden items-center gap-8 lg:flex" aria-label="Main navigation" data-id="element-170" data-mp="1832zz2owth31">
            {navLinks.map(link => <Link key={link.href} to={link.href} className="font-display text-[13px] font-bold uppercase tracking-wider text-navy transition-colors hover:text-gold" data-id="element-171" data-mp="1cztazbluxmhl">
                {link.label}
              </Link>)}
            <a href={contact.phoneHref} className="flex items-center gap-2 font-display text-[13px] font-bold uppercase tracking-wider text-navy transition-colors hover:text-gold" data-id="element-172" data-mp="1et459uipnc73">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="h3andq16kfeq" />
              {contact.phone}
            </a>
            <a href={contact.phoneHref} className="flex items-center gap-2 bg-gold px-6 py-3 font-display text-[12px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-gold-dark" data-id="element-174" data-mp="w09xplnf2mcw">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="27e5gr5hfzf9e" />
              Call Us
            </a>
          </nav>

          <button type="button" onClick={() => setOpen(v => !v)} className="flex h-10 w-10 items-center justify-center text-navy lg:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-176" data-mp="22iq2wdjfpjcz">
            {open ? <XIcon className="h-6 w-6" data-id="element-177" data-mp="250s3c4e2acts" /> : <MenuIcon className="h-6 w-6" data-id="element-178" data-mp="2523c6imd6arr" />}
          </button>
        </div>

        {open && <nav id="mobile-nav" className="border-t border-gray-200 bg-white px-6 py-4 lg:hidden" aria-label="Mobile navigation" data-id="element-179" data-mp="2srnuczap13zz">
            <ul className="flex flex-col" data-id="element-180" data-mp="2jyud4wborujh">
              {navLinks.map(link => <li key={link.href} data-id="element-181" data-mp="2nznybhxquv8o">
                  <Link to={link.href} onClick={() => setOpen(false)} className="block border-b border-gray-100 py-3 font-display text-sm font-bold uppercase tracking-wider text-navy" data-id="element-182" data-mp="2nyl9rgnw94vx">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
            <div className="mt-4 flex flex-col gap-3" data-id="element-183" data-mp="1ns9coy8yrw1q">
              <a href={contact.phoneHref} className="flex items-center gap-2 text-sm font-semibold text-navy" data-id="element-184" data-mp="1nuvjuwry09jf">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-185" data-mp="1et5urxlj9mot" />
                {contact.phone}
              </a>
              <a href={contact.phoneHref} className="bg-gold px-6 py-3 text-center font-display text-[12px] font-bold uppercase tracking-widest text-white" data-id="element-186" data-mp="2bhvb3jhii78o">
                Call Us
              </a>
            </div>
          </nav>}
      </div>
    </header>;
}